import TextLink, { type HeadlessLinkProps, headlessLinkProps } from './TextLink'
export * from './types'
export { TextLink, headlessLinkProps, type HeadlessLinkProps }
